<div class="d-flex justify-content-between align-items-center m-b-20">
  <fui-heading [text]="'Events Manager'" [level]="5"></fui-heading>
  <div class="d-flex align-items-center">
    <myp-segmented-bar
      class="m-r-20"
      [options]="[
        { name: 'List', id: 'list', selected: viewMode === 'list' },
        { name: 'Calendar', id: 'calendar', selected: viewMode === 'calendar' },
      ]"
      (selected)="switchView($event)"
    ></myp-segmented-bar>
    <button class="btn btn-primary btn-sm text-nowrap" (click)="createEvent()">+ Create Event</button>
  </div>
</div>

@if (viewMode === "list") {
  <div class="d-flex align-items-center m-b-20">
    <input class="form-control m-r-10" style="width: 250px" placeholder="Search by title..." [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" />
    <!-- <select class="form-control m-r-10" style="width: 150px" [(ngModel)]="statusFilter" (ngModelChange)="onStatusChange()">
      <option value="">All Statuses</option>
      <option value="draft">Draft</option>
      <option value="published">Published</option>
      <option value="archived">Archived</option>
    </select> -->
    <myp-switch [active]="showPastEvents" label="Show past events" [labelToRight]="true" (toggle)="togglePastEvents()"></myp-switch>
    @if (hasSeriesEvents) {
      <button class="btn btn-blank btn-sm m-l-20 text-nowrap" (click)="toggleAllSeries()">
        <fa-icon [icon]="allSeriesExpanded ? 'compress' : 'expand'" class="m-r-5"></fa-icon>
        {{ allSeriesExpanded ? ("admin_portal.collapse_all" | translate) : ("admin_portal.expand_all" | translate) }}
      </button>
    }
  </div>

  @if (loading) {
    <myp-inline-loader [loading]="loading" height="200px" spinnerName="events-loader"></myp-inline-loader>
  }

  @if (!loading && filteredEvents.length === 0) {
    <div class="text-center m-t-50">
      <span class="text-muted">No events found.</span>
    </div>
  }

  @if (!loading && filteredEvents.length > 0) {
    @for (event of filteredEvents; track event) {
      <myp-list-item
        [title]="event._displayTitle"
        [subData]="event._subData"
        [metadata]="event._metadata"
        [showImage]="!!event.image_url"
        [photo]="event.image_url"
        [imageRound]="false"
        [includeChevron]="false"
        [includeBottomBorder]="true"
        [style.opacity]="event._isPast ? 0.6 : 1"
        (itemClicked)="onMainItemClick(event)"
      >
        <div class="button-content">
          @if (!isCompact) {
            @if (event.parent_event_id || event.is_template || event.recurring_rule) {
              <button class="fa-button m-r-20" ngbTooltip="Add occurrence" (click)="addOccurrence(event); $event.stopPropagation()">
                <fa-icon icon="plus"></fa-icon>
              </button>
              @if (event.parent_event_id) {
                <button class="fa-button m-r-20" ngbTooltip="Show all occurrences" (click)="toggleSeries(event); $event.stopPropagation()">
                  <fa-icon [icon]="event._expanded ? 'chevron-up' : 'chevron-down'"></fa-icon>
                </button>
              }
            }
            @if (event._slug) {
              <button class="fa-button m-r-20" ngbTooltip="Copy URL" (click)="copyEventUrl(event); $event.stopPropagation()">
                <fa-icon icon="link"></fa-icon>
              </button>
            }
            <button class="fa-button m-r-20" ngbTooltip="Edit" (click)="editSeriesTemplate(event); $event.stopPropagation()">
              <fa-icon icon="pencil"></fa-icon>
            </button>
            @if (event._deleting) {
              <fa-icon icon="spinner" animation="spin"></fa-icon>
            } @else {
              <button class="fa-button" ngbTooltip="Delete" (click)="deleteEvent(event, event._isRecurring); $event.stopPropagation()">
                <fa-icon icon="trash"></fa-icon>
              </button>
            }
          } @else {
            @if (event.parent_event_id) {
              <button class="fa-button m-r-20" ngbTooltip="Show all occurrences" (click)="toggleSeries(event); $event.stopPropagation()">
                <fa-icon [icon]="event._expanded ? 'chevron-up' : 'chevron-down'"></fa-icon>
              </button>
            }
            <button class="fa-button" (click)="showEventActions(event); $event.stopPropagation()">
              <fa-icon icon="ellipsis-vertical"></fa-icon>
            </button>
          }
        </div>
      </myp-list-item>
      @if (event._expanded && event._seriesEvents) {
        <div class="m-l-40">
          @for (instance of event._seriesEvents; track instance) {
            <myp-list-item
              [title]="instance._displayTitle"
              [metadata]="instance._metadata"
              [showImage]="!!instance.image_url"
              [photo]="instance.image_url"
              [imageRound]="false"
              [includeChevron]="false"
              [includeBottomBorder]="true"
              [style.opacity]="instance._isPast ? 0.5 : 1"
              (itemClicked)="editChildEvent(instance)"
            >
              <div class="button-content">
                @if (!isCompact) {
                  <button class="fa-button m-r-20" ngbTooltip="Edit" (click)="editChildEvent(instance); $event.stopPropagation()">
                    <fa-icon icon="pencil"></fa-icon>
                  </button>
                  @if (instance._deleting) {
                    <fa-icon icon="spinner" animation="spin"></fa-icon>
                  } @else {
                    <button class="fa-button" ngbTooltip="Delete" (click)="deleteEvent(instance); $event.stopPropagation()">
                      <fa-icon icon="trash"></fa-icon>
                    </button>
                  }
                } @else {
                  <button class="fa-button" (click)="showChildEventActions(instance); $event.stopPropagation()">
                    <fa-icon icon="ellipsis-vertical"></fa-icon>
                  </button>
                }
              </div>
            </myp-list-item>
          }
        </div>
      }
    }
  }
}

@if (viewMode === "calendar") {
  @if (loading) {
    <myp-inline-loader [loading]="loading" height="200px" spinnerName="events-calendar-loader"></myp-inline-loader>
  }
  @if (!loading) {
    <fui-calendar [options]="calendarOptions"></fui-calendar>
  }
}

<ng-template #deleteConfirmModal>
  <div class="modal-header">
    <h4 class="modal-title">Delete Event</h4>
  </div>
  <div class="modal-body">
    @if (eventToDelete) {
      @if (deleteSeriesMode || eventToDelete.is_template || (eventToDelete.recurring_rule && !eventToDelete.parent_event_id)) {
        <p>Are you sure you want to delete "{{ eventToDelete._displayTitle }}" and all its occurrences?</p>
      } @else {
        <p>Are you sure you want to delete "{{ eventToDelete._displayTitle }}"?</p>
        @if (eventToDelete.start_datetime) {
          <p>
            <strong>Date:</strong>
            {{ eventToDelete._deleteDate }}
          </p>
        }
      }
    }
    <div class="text-center">
      @if (deleteSeriesMode || eventToDelete?.is_template || (eventToDelete?.recurring_rule && !eventToDelete?.parent_event_id)) {
        <button class="btn btn-danger" (click)="confirmDelete(true)">Delete Entire Series</button>
      } @else {
        <button class="btn btn-danger" (click)="confirmDelete(false)">Delete</button>
      }
      <br />
      <br />
      <button class="btn btn-blank" (click)="cancelDelete()">Cancel</button>
    </div>
  </div>
</ng-template>
